var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mkBox"},[_c('mavon-editor',{staticClass:"md",attrs:{"value":_vm.context,"subfield":_vm.prop.subfield,"defaultOpen":_vm.prop.defaultOpen,"toolbarsFlag":_vm.prop.toolbarsFlag,"editable":_vm.prop.editable,"scrollStyle":_vm.prop.scrollStyle,"boxShadow":_vm.prop.boxShadow,"ishljs":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }